import { ISelectDescribeData, ITaggedType, ITaggedField, ITemplateFields } from '@routes/private/Editor/types';
import { IField } from '@state/dsconfig/types';
import { IElement } from '@routes/private/Editor/types';
import { IFieldAlias } from '@routes/private/Templates/components/NewTemplate/types'
import { cloneDeep } from 'lodash';
import { findElementById, findElementsByIds } from './editor';
import { isElementOrParentHiddenInOtherThanMultiEditing } from './visibility';
import { UndoIcon } from '@assets/icons/undoIcon';
const uuid = require('react-uuid');

export const GetTaggedElements = (id: string,taggedCategories?: ITaggedField[]):ITaggedField|undefined => {
    let index = -1;
    if(taggedCategories) {
        index = taggedCategories?.map((taggedCategory)=>{return taggedCategory.id;}).indexOf(id);
    }
    if(taggedCategories && index!==-1) {
        return taggedCategories[index];
    }
    return undefined;
}

export const GetTotalTaggedCategories = (sectionId: string,taggedCategories?: ITaggedField[],parentCategories?: IField[],templateCategories?: ITemplateFields[]):number => {
    let total=0;
    parentCategories?.forEach(category => {
        const taggetFields = GetTaggedElements(category.id,taggedCategories);
        if (taggetFields && taggetFields.taggedElements && taggetFields.taggedElements.length>0) {
            total += 1;
        }
        if (templateCategories) {
            templateCategories.filter((templateCategory)=>{return templateCategory.parentId==category.id;}).forEach(templateCategory => {
                const taggetFields = GetTaggedElements(templateCategory.id,taggedCategories);
                if(taggetFields && taggetFields.taggedElements && taggetFields.taggedElements.length>0) {
                    total += 1;
                }
            });
        }
    });
    return total;
}

export const getTaggedElementsId = (categoriesId: string[], taggedFields: ITaggedField[]): string[] => {
    let taggedElementsId: string [] = [];
    for(let i=0;i<categoriesId.length;i++) {
        let index = taggedFields.map((taggedField)=>{ return taggedField.id;}).indexOf(categoriesId[i]);
        if (index!==-1) {
            taggedElementsId.push(...taggedFields[index].taggedElements);
        }
    }
    return taggedElementsId;
}
  
export const getTaggedElements = (categoryId: string[], taggedFields: ITaggedField[], data: IElement[]): (IElement|undefined)[] => {
    const taggedElementsIds = getTaggedElementsId(categoryId, taggedFields);
    return findElementsByIds(data, taggedElementsIds);
}
  
export const getTaggedVisibleElementsId = (categoriesId: string[], taggedFields: ITaggedField[], data: IElement[]): string[] => {
    let taggedElementsId: string [] = [];
    for(let i=0;i<categoriesId.length;i++) {
        let index = taggedFields.map((taggedField)=>{ return taggedField.id;}).indexOf(categoriesId[i]);
        if (index!==-1) {
            const allTaggedElementsIds = taggedFields[index].taggedElements;
            for(let i=0; i<allTaggedElementsIds.length; i++) {
                const isHidden = isElementOrParentHiddenInOtherThanMultiEditing(allTaggedElementsIds[i], data);
                if (isHidden===false) taggedElementsId.push(allTaggedElementsIds[i]);
            } 
        }
    }
    return taggedElementsId;
}
  
export const getTaggedVisibleElements = (categoryId: string[], taggedFields: ITaggedField[], data: IElement[]): (IElement|undefined)[] => {
    const taggedElementsIds = getTaggedVisibleElementsId(categoryId, taggedFields, data);
    return findElementsByIds(data, taggedElementsIds);
}

export const getCategoryElementTagged = (elementId: string, taggedFields: ITaggedField[]): string | undefined => {
    if (taggedFields) {
        for (let i=0;i<taggedFields.length;i++){
        if (taggedFields[i].taggedElements.includes(elementId)){
            return taggedFields[i].id;
        }
        }
    }
    return undefined;
}

export const getCategoryType = (categoryId: string, templateFields: ITemplateFields[]) => {
    if (templateFields) {
        for(let i=0;i<templateFields.length;i++)
        {
        if (templateFields[i].id===categoryId){
            return "TEMPLATE_FIELD";
        }
        }
    }
    return "MAIN_FIELD"
}

function getMainCategoryName(categoryId: string, categories: IField[]): string {
    for(let i=0;i<categories.length;i++) {
        if (categories[i].id===categoryId) {
            return categories[i].name;
        }
        if (categories[i].fields) {
            let name = getMainCategoryName(categoryId,categories[i].fields!);
            if (name!=="") return name;
        }
    }
    return "";
}

export const getCategoryName = (categoryId: string, categories: IField[], templateFields: ITemplateFields[]): string => {
    for(let i=0;i<templateFields.length;i++)
    {
        if (templateFields[i].id===categoryId){
            return templateFields[i].name;
        }
    }
    return getMainCategoryName(categoryId, categories);
}

function getField(fieldId: string, categories: IField[]): IField|undefined {
    for(let i=0;i<categories.length;i++) {
        if (categories[i].id===fieldId) {
            return categories[i];
        }
        if (categories[i].fields) {
            let field = getField(fieldId,categories[i].fields!);
            if (field!==undefined) return field;
        }
    }
    return undefined;
}

export const existsFieldInCategory = (fieldId: string, category: IField, deepCheck: boolean): boolean => {
    if (!category.fields) return false;
    for (let i=0;i<category.fields.length;i++) {
        if (category.fields[i].id === fieldId) {
            return true;
        }
        if (deepCheck) {
            if (existsFieldInCategory(fieldId, category.fields[i], deepCheck)) {
                return true;
            }
        }
    }
    return false;
}

export const getParentMainCategory = (fieldId: string, categories: IField[]): IField|undefined => {
    let found: boolean = false;
    for (let i=0;i<categories.length;i++) {
        if (existsFieldInCategory(fieldId, categories[i], true)) {
            return categories[i];
        }
    }
    return undefined;
}

export const getParentCategory = (elementId: string, categories?: IField[], templateFields?: ITemplateFields[], taggedCategories?: ITaggedField[]): IField|undefined => {
    if (!taggedCategories || !categories) return undefined;
    let fieldId: string|undefined = undefined; 
    let type: ITaggedType|undefined = undefined; 
    for (let i=0;i<taggedCategories!.length;i++) {
        if (taggedCategories[i].taggedElements) {
            let found=false;
            for (let a=0;a<taggedCategories[i].taggedElements.length;a++) {
                if (elementId===taggedCategories[i].taggedElements[a]) {
                    fieldId = taggedCategories[i].id;
                    type = taggedCategories[i].type;
                    found=true;
                    break;
                }
            }
            if (found) break;
        }
    }
    if (fieldId===undefined) return undefined;
    if (type==="TEMPLATE_FIELD") {
        if (!templateFields) return undefined;
        for (let i=0;i<templateFields.length;i++) {
            if (templateFields[i].id === fieldId) {
                fieldId = templateFields[i].parentId;
                break;
            }
        }
    }
    const field = getField(fieldId,categories);
    if (field===undefined) return undefined;
    const parentField = getParentMainCategory(field.id,categories);
    return parentField;
}

export const getParentCategoryColor = (elementId: string, categories?: IField[], templateFields?: ITemplateFields[], taggedCategories?: ITaggedField[]): string|undefined => {
    const parentCategory = getParentCategory(elementId, categories, templateFields, taggedCategories);
    return parentCategory?.color;
}

function removeTaggedElementFromOtherField(elementId: string, addedToField: string, automaticTaggedFields: ITaggedField[]): ITaggedField[]{
    for (let i=0;i<automaticTaggedFields.length;i++) {
        if (automaticTaggedFields[i].id !== addedToField) {
            automaticTaggedFields[i].taggedElements = automaticTaggedFields[i].taggedElements.filter(taggedElement => taggedElement !== elementId);
            if (automaticTaggedFields[i].taggedElements.length === 0) {
                automaticTaggedFields.splice(i, 1);
                i--;
            }
        }
    }
    return automaticTaggedFields;
}

function addTaggedElement(fieldId: string, taggedType: ITaggedType, element: IElement, automaticSelectDescribeData: ISelectDescribeData): ISelectDescribeData {
    let index = automaticSelectDescribeData.taggedFields.map((taggedField)=>{ return taggedField.id }).indexOf(fieldId);
    if (index===-1) {
        index = automaticSelectDescribeData.taggedFields.length; 
        if (!element.children) {
            automaticSelectDescribeData.taggedFields.push({id: fieldId, type: taggedType, taggedElements: []});
        }
    }
    if (!element.children) {
        if (!automaticSelectDescribeData.taggedFields[index].taggedElements.includes(element.id)) {
            automaticSelectDescribeData.taggedFields[index].taggedElements.push(element.id);
        }
        automaticSelectDescribeData.taggedFields = removeTaggedElementFromOtherField(element.id, fieldId, automaticSelectDescribeData.taggedFields);
    }
    if (element.children) {
        for(let i=0;i<element.children.length;i++) {
            automaticSelectDescribeData = addTaggedElement(fieldId, taggedType, element.children[i], automaticSelectDescribeData);
        }
    }
    return automaticSelectDescribeData;
}

export function endsWithNumber(str: string): boolean {
    if (str && str.length>0) {
        const lastdigit = str.substr(str.length-1,1);
        if(lastdigit==='0' || lastdigit==='1' || lastdigit==='2' || lastdigit==='3' || lastdigit==='4' || lastdigit==='5' || lastdigit==='6' || lastdigit==='7' || lastdigit==='8' || lastdigit==='9') {
            return true;
        }
    }
    return false;
}

export function getEndNumber(str: string): number | undefined {
    if (!str) return undefined;
    str = str.replaceAll(' ','');
    let position=str.length-1;
    while(position>=0) {
        const digit = str.substr(position,1);
        if (digit!=='0' && digit!=='1' && digit!=='2' && digit!=='3' && digit!=='4' && digit!=='5' && digit!=='6' && digit!=='7' && digit!=='8' && digit!=='9') {
            if(position===str.length-1) {
                return undefined;
            }
            else {
                return parseInt(str.substr(position+1));
            }
        }
        if (position===0) {
            return parseInt(str);
        }
        position--;
    }
    return undefined;
}

export const getAutomaticSelectDescribe = (elements: IElement[], fieldsAliases: IFieldAlias[], mainCategories: IField[], automaticSelectDescribeData?: ISelectDescribeData): ISelectDescribeData => {
    if (!automaticSelectDescribeData) {
        automaticSelectDescribeData = { taggedFields: [], templateFields: []};
    }
    for (let i=0;i<elements.length;i++) {
        if (elements[i] && elements[i].name) {
            let index = fieldsAliases.map((fieldAlias) => { return fieldAlias.alias.toUpperCase().replaceAll(' ','').replace(/[0-9]/g,'') }).indexOf(elements[i].name.toUpperCase().replaceAll(' ','').replace(/[0-9]/g, ''));
            if (index !== -1) {
                let fieldId = fieldsAliases[index].id;
                let taggedType: ITaggedType = "MAIN_FIELD";
                if (endsWithNumber(elements[i].name)) {
                    taggedType = "TEMPLATE_FIELD";
                    let endNumber = getEndNumber(elements[i].name);
                    let templateFieldName = getMainCategoryName(fieldsAliases[index].id, mainCategories) + " " + endNumber?.toString();
                    let idx = automaticSelectDescribeData.templateFields.map((templateField)=>{ return templateField.name }).indexOf(templateFieldName);
                    if (idx === -1) {
                        fieldId = uuid();
                        automaticSelectDescribeData.templateFields.push({id: fieldId, parentId: fieldsAliases[index].id, name: templateFieldName});
                    }
                    else {
                        fieldId = automaticSelectDescribeData.templateFields[idx].id;
                    }
                }
                automaticSelectDescribeData = addTaggedElement(fieldId, taggedType, elements[i], automaticSelectDescribeData);
            }
        }
        if (elements[i].children) {
            automaticSelectDescribeData = getAutomaticSelectDescribe(elements[i].children!, fieldsAliases, mainCategories, automaticSelectDescribeData);
        }
    }
    return automaticSelectDescribeData;
}

export const getAliases = (fields: IField[], fieldsAliases?: IFieldAlias[]): IFieldAlias[] => {
    if (!fieldsAliases) {
        fieldsAliases = [];
    }
    for (let i=0;i<fields.length;i++) {
        if (!fields[i].fields || fields[i].fields?.length === 0) {
            fieldsAliases.push({id: fields[i].id, alias: fields[i].name});
            if (fields[i].aliases) {
                for (let j=0;j<fields[i].aliases!.length;j++) {
                    fieldsAliases.push({id: fields[i].id, alias: fields[i].aliases![j]});
                }
            }
        }
        if (fields[i].fields) {
            fieldsAliases = getAliases(fields[i].fields!, fieldsAliases);
        }
    }
    return fieldsAliases;
}

export const FindNextNumber = (parentCategoryId: string, parentCategoryName: string, selectDescribe?: ISelectDescribeData): number => {
    let categoriesNumbers: number[] = [];
    selectDescribe?.templateFields?.forEach((category) => {
        if (category.parentId === parentCategoryId){
            let position = parseInt(category.name.replace(parentCategoryName,""));
            if(position){
                categoriesNumbers.push(position);
            }
        }
    });
    categoriesNumbers.sort((a:number, b:number)=>{
        if(a>b) return 1;
        else if(a<b) return -1;
        else return 0;
    });
    for (let i = 0; i < categoriesNumbers.length; i++) {
        if(categoriesNumbers[i]!=i+1){
            return i+1;
        }
    }
    return categoriesNumbers.length+1;
}

export const getSelectDescribeCopyPaste = (newElementId: string, copiedElement: IElement, actualSelectDescribe: ISelectDescribeData, categories: IField[]): ISelectDescribeData|undefined => {
    let newSelectDescribe: ISelectDescribeData|undefined = cloneDeep(actualSelectDescribe);
    let changed=false;
    if (actualSelectDescribe && actualSelectDescribe.taggedFields && actualSelectDescribe.taggedFields.length>0) {
        for (let i=0;i<actualSelectDescribe.taggedFields.length;i++) {
            if (actualSelectDescribe.taggedFields[i].taggedElements) {
                for (let a=0;a<actualSelectDescribe.taggedFields[i].taggedElements.length;a++) {
                    if (actualSelectDescribe.taggedFields[i].taggedElements[a] === copiedElement.id) {
                        changed = true;
                        let parentCategoryId: string = "";
                        if (getCategoryType(actualSelectDescribe.taggedFields[i].id, actualSelectDescribe.templateFields) === "MAIN_FIELD") {
                            parentCategoryId = actualSelectDescribe.taggedFields[i].id;
                        }
                        else {
                            for(let j=0;j<actualSelectDescribe.templateFields.length;j++) {
                                if (actualSelectDescribe.templateFields[j].id === actualSelectDescribe.taggedFields[i].id) {
                                    parentCategoryId = actualSelectDescribe.templateFields[j].parentId;
                                    break;
                                }
                            }
                        }
                        const parentCategoryName = getCategoryName(parentCategoryId, categories, actualSelectDescribe.templateFields);
                        const nextNumber = FindNextNumber(parentCategoryId, parentCategoryName, actualSelectDescribe);
                        const newTemplateFieldName = parentCategoryName + nextNumber.toString();
                        if (!newSelectDescribe.templateFields) newSelectDescribe.templateFields = [];
                        if (!newSelectDescribe.taggedFields) newSelectDescribe.taggedFields = [];
                        const newCategoryId = uuid();
                        newSelectDescribe.templateFields.push({id: newCategoryId, parentId: parentCategoryId, name: newTemplateFieldName});
                        newSelectDescribe.taggedFields.push({id: newCategoryId, type: "TEMPLATE_FIELD", taggedElements: [newElementId]});
                        break;
                    }
                    if (changed) {
                        break;
                    }
                }
            }
        }
    }
    if (!changed) {
        newSelectDescribe = undefined;
    }
    return newSelectDescribe;
}

export const revomeFromSelectAndDescribe = (elementId: string, actualSelectDescribe: ISelectDescribeData): ISelectDescribeData|undefined => {
    let newSelectDescribe: ISelectDescribeData|undefined = cloneDeep(actualSelectDescribe);
    let changed=false;
    if (newSelectDescribe && newSelectDescribe.taggedFields && newSelectDescribe.taggedFields.length>0) {
        for (let i=0;i<newSelectDescribe.taggedFields.length;i++) {
            if (newSelectDescribe.taggedFields[i].taggedElements) {
                for (let a=0;a<newSelectDescribe.taggedFields[i].taggedElements.length;a++) {
                    if (newSelectDescribe.taggedFields[i].taggedElements[a] === elementId) {
                        changed = true;
                        newSelectDescribe.taggedFields[i].taggedElements.splice(a,1);
                        break;
                    }
                    if (changed) {
                        break;
                    }
                }
            }
        }
    }
    if (!changed) {
        newSelectDescribe = undefined;
    }
    return newSelectDescribe;
}

export const getSelectDescribeCopyPasteArtboardChild=(newChilds: IElement[], copiedChilds:IElement[],actualSelectDescribe: ISelectDescribeData, categories: IField[] ): ISelectDescribeData|undefined=>{
    let newSelectDescribe: ISelectDescribeData|undefined = cloneDeep(actualSelectDescribe);
    if (copiedChilds)
    {
        for(let n=0; n<copiedChilds.length;n++){
            
            if (newSelectDescribe && newSelectDescribe.taggedFields && newSelectDescribe.taggedFields.length>0) {
                for (let i=0;i<newSelectDescribe.taggedFields.length;i++) {
                    if (newSelectDescribe.taggedFields[i].taggedElements) {
                        for (let a=0;a<newSelectDescribe.taggedFields[i].taggedElements.length;a++) {
                            if (newSelectDescribe.taggedFields[i].taggedElements[a] === copiedChilds[n].id) {
                                newSelectDescribe.taggedFields[i].taggedElements.push(newChilds[n].id);
                            }
                        }
                    }
                }
            }

            if (copiedChilds[n].children && newChilds[n].children && newSelectDescribe)
                newSelectDescribe = getSelectDescribeCopyPasteArtboardChild(newChilds[n].children!,copiedChilds[n].children!,newSelectDescribe,categories);

        }
    }
    return newSelectDescribe;
}

export const getDeepestElements = (group: IElement) => {
    let elements: IElement[] = [];
    group.children?.map(element => {
        if (["Image", "Text", "Shape"].includes(element.type)) elements = [...elements, element];
        if (element.children) elements = [...elements, ...getDeepestElements(element)];
    });
    return elements;
}
